type NotificationOptions = {
  // biome-ignore-start lint/style/useNamingConvention: API expects in snake_case
  email_new_comments: boolean;
  email_new_rsvp: boolean;
  notify_only_my_activity: boolean;
  push_new_comments: boolean;
  push_new_rsvp: boolean;
  notify_only_my_activity_push: boolean;
  // biome-ignore-end lint/style/useNamingConvention: API expects in snake_case
};

export type Payload = {
  // biome-ignore-start lint/style/useNamingConvention: API expects in snake_case
  name: string;
  email?: string;
  phone: string;
  response: string;
  adults_in_party: number;
  kids_in_party: number;
  comments: string;
  guest_id?: string;
  vendor_optin?: string[];
  optin?: boolean;
  sms_optin?: boolean;
  notification_options?: NotificationOptions;
  // biome-ignore-end lint/style/useNamingConvention: API expects in snake_case
};

export enum RsvpStatuses {
  Yes = 'Yes',
  Maybe = 'Maybe',
  No = 'No',
}
